module.exports = __webpack_public_path__ + "img/HowtoCategory2.002289de.png";